import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { RouterProvider } from 'react-router-dom'
import { configureHttp, createQueryClient } from '../api'
import { configureSignOut, httpAuth } from '../auth'
import { ConfirmHost, notify, Notifier } from '../ui'
import { createRouter } from './router'

/**
 * Wire the layers together once: HTTP → auth, mutation errors → the one
 * notifier (ADR 0010), sign-out → clear the query cache and route to login.
 */
export function createApp() {
  configureHttp(httpAuth)
  const queryClient = createQueryClient({
    onMutationError: (error) => {
      notify({ tone: 'error', message: error instanceof Error ? error.message : 'Request error' })
    }
  })
  const router = createRouter()
  configureSignOut({
    onSignedOut: () => {
      queryClient.clear()
    },
    navigate: (path) => {
      void router.navigate(path)
    }
  })
  return { queryClient, router }
}

export function App({ app }: { app: ReturnType<typeof createApp> }) {
  return (
    <StrictMode>
      <QueryClientProvider client={app.queryClient}>
        <RouterProvider router={app.router} />
        <ConfirmHost />
        <Notifier />
      </QueryClientProvider>
    </StrictMode>
  )
}
